export default __webpack_public_path__ + "static/media/ic_chile.eb621dc0.svg";